import { Box } from '@mui/material';
import { FC } from 'react';
import { useRootContext } from '../../../../../../components/RootContainer';
import PermissionsManager from './context';

const PermissionPage: FC = () => {
  const {
    ChainApi: {
      settings: {
        acl: { permissionManager },
      },
    },
  } = useRootContext();

  return (
    <Box
      sx={{
        height: '100%',
        px: 0,
        backgroundColor: '#fff',
        border: 'solid 1px',
        borderColor: 'colors.gray.o20',
      }}
    >
      <PermissionsManager permissionManagerService={permissionManager} />
    </Box>
  );
};

export default PermissionPage;
